let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("37iLc")).then(() => parcelRequire('6o7A6'));